<template>
  <b-tab
    :lazy="lazy"
    :active="active"
    :title-link-class="navLinkClass"
    :title-item-class="navItemClass"
    class="custom-tab-item"
    tag="div"
    @click="$emit('click', $event)"
  >
    <slot />
    <template #title>
      {{ title }}
      <i
        v-if="hasError"
        class="fas fa-exclamation-circle text-danger error-icon"
      ></i>
    </template>
  </b-tab>
</template>

<script>
import { BTab } from "bootstrap-vue";
export default {
  name: "CustomTab",
  components: {
    BTab
  },
  props: {
    lazy: {
      type: Boolean,
      default: () => false
    },
    title: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: () => false
    },
    navItemClass: {
      type: [Object, String],
      default: () => ""
    },
    navLinkClass: {
      type: [Object, String],
      default: () => ""
    },
    hasError: {
      type: Boolean,
      default: () => false
    }
  }
};
</script>
<style scoped>
.error-icon {
  position: absolute;
  margin-left: 5px;
  font-size: 18px;
}
</style>
